<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalOutsideLimit",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"8. (VI) What limit is required for any one loss for property elsewhere than at the Proposer's Premises stated in Question 1 (b)? (This limit will NOT apply to propety in any safe deposit vault or bank vault)",
					component: "longText",
					bindTo: "case.facts.outsidePremisesLossLimit"
				}
			]
		}
	}
}
</script>
